import { createEvent} from 'ics';
import { sleep } from '../../../library-js/animation/sleep';
import { DateFormatter } from '../../../library-js/date/DateFormatter';
import { DateHelper } from '../../../library-js/date/DateHelper';
import { DateParser } from '../../../library-js/date/DateParser';
import { AttributeValue } from '../../../library-js/dom-tools/AttributeValue';
import { ClassFlag } from '../../../library-js/dom-tools/ClassFlag';
import { ElementAttribute } from '../../../library-js/dom-tools/ElementAttribute';
import { ElementSelector } from '../../../library-js/dom-tools/ElementSelector';
import { ElementType } from '../../../library-js/dom-tools/ElementType';
import { OnChange, OnClick, OnSelectStart } from '../../../library-js/dom-tools/EventListeners';
import { HTMLEditor } from '../../../library-js/dom-tools/HTMLEditor';
import { LinkType } from '../../../library-js/dom-tools/LinkResolver';
import { DOMOrientation } from '../../../library-js/dom/DOMOrientation';
import { RegExpUtility } from '../../../library-js/text/RegExpUtility';
import { CuratedItem } from '../../templates/article/CuratedItem';
import { Rokojori } from '../Rokojori';
import { DateRange } from '../../../library-js/date/DateRange';

export class CalenderEvents
{
  static readonly time = new ElementAttribute( "time" ); 
  static readonly selector = new ElementSelector( CuratedItem.point, CalenderEvents.time );
  static readonly viewTypeSelector = new ElementAttribute( "calender-view-selector" ) ;

  static readonly calenderEvents = new ElementAttribute( "calender-events" );
  static readonly eventType = new ElementAttribute( "event-type" );
  static readonly location  = new ElementAttribute( "location" );  

  static readonly noEvent = new ElementAttribute( "no-event" );
  static readonly cancelled = new ClassFlag( "cancelled" );

  static viewTypeSwitcher:HTMLSelectElement;

  static applyOnDocument()
  {
    CalenderEvents.selector.forAllInDoc( e => CalenderEvents.applyOnElement( e ) );
    CalenderEvents.calenderEvents.forEachInDoc( e => CalenderEvents.applyOnCalender( e ) );    
  }


  static applyOnCalender( e:Element ) 
  {
    let viewType = CalenderEvents.viewTypeSelector.query<HTMLSelectElement>( e.ownerDocument );

    let viewTypes = 
    [
      { name: "compact", value: CuratedItem.compact },
      { name: "list", value: CuratedItem.list },
      { name: "all-details", value: CuratedItem.allDetails }
    ]

    var viewTypeName =  viewType.value.toLowerCase();
    let viewAttribute = viewTypes.find( v => v.name === viewTypeName );

    if ( viewAttribute )
    {
      viewAttribute.value.set( e );
      CalenderEvents.setCloseButtonYOnPortrait( e );
    }    

    if ( CalenderEvents.viewTypeSwitcher !== viewType )
    {
      CalenderEvents.viewTypeSwitcher = viewType;

      OnChange.add( viewType, ()=> CalenderEvents.applyOnCalender( e ) );
    }
  }

  static createButton( htmlElement:HTMLElement, title:string, icon:string = "add" )
  {
    let curatedPointAsButton = CuratedItem.point.create( title );
    new ElementAttribute( "icon" ).to( curatedPointAsButton, icon );
    curatedPointAsButton = Rokojori.$.templatesManager.processElement( curatedPointAsButton );
    let relativePath =  Rokojori.$.pageHandler.currentPage;
    Rokojori.$.pageHandler.rootPathResolver.process( curatedPointAsButton, relativePath );

    ClassFlag.button.set( curatedPointAsButton );

    let parent = htmlElement.parentElement;
    let curatedPoints = CuratedItem.point.queryAll( parent );

    HTMLEditor.addAfter( curatedPoints[ curatedPoints.length - 1 ], curatedPointAsButton );    

    return curatedPointAsButton;
  }

  static async setCloseButtonYOnPortrait( e:Element )
  { 
    if ( DOMOrientation.isLandscape )
    {
      return;
    } 

    let viewType = CalenderEvents.viewTypeSelector.query<HTMLSelectElement>( e.ownerDocument );

   

    for ( let i = 0; i < 10; i++ )
    {
      let viewTypes = 
      [
        { name: "compact", value: CuratedItem.compact },
        { name: "list", value: CuratedItem.list },
        { name: "details", value: CuratedItem.allDetails }
      ]
  
      var viewTypeName =  viewType.value.toLowerCase();
      let viewAttribute = viewTypes.find( v => v.name.includes( viewTypeName ) );
  
      if ( CuratedItem.list !== viewAttribute.value )
      {
        return;
      }
      
      await sleep ( 1000 );
      CuratedItem.type.forAllInDoc( e => CalenderEvents.changeCloseButtonY( e ) );
    }

  }

  static changeCloseButtonY( e:Element )
  {        
    let closeButton = CuratedItem.closeButton.query( e ) as HTMLElement;

    if ( ! closeButton )
    {
      return;
    }

    let portraitOnlyType = new ElementType( "portrait--only" );

    let potraitOnlyPart = portraitOnlyType.queryDirectChild( e );

    let title = CuratedItem.title.query( potraitOnlyPart );
    
    
    let eRect = e.getBoundingClientRect();
    let rect = title.getBoundingClientRect();

    closeButton.style.top = `calc( ${rect.top - eRect.top}px + var(--sw) * 6 )`;
  }

  static applyOnElement( e:Element )
  {
    if ( CalenderEvents.noEvent.in( e ) )
    {
      return;
    }

    let cancelled = CalenderEvents.cancelled.in( e );
    
    let dateTimeElement = e;
    
    let dateString = dateTimeElement.textContent;
  
    let dateRange = DateParser.parseInternationalEnglish( dateString );

    if ( ! dateRange )
    {
      return;
    }

    dateTimeElement.innerHTML = dateTimeElement.innerHTML.replace( /(\d)(st|nd|rd|th)/g, "$1." );

    let weekdayStart = dateRange.start.getDay();
    let weekdayEnd   = dateRange.end.getDay();

    let startDay = DateFormatter.getWeekDayInEnglish3( weekdayStart ).toUpperCase();
    let endDay   = DateFormatter.getWeekDayInEnglish3( weekdayEnd ).toUpperCase(); 

    let weekDayInfo = "";

    if ( startDay === endDay )
    {
      weekDayInfo = `<week-day>${startDay}</week-day>`
    }
    else
    {
      weekDayInfo = `<week-day>${startDay} - ${endDay}</week-day>`
    }

    let img = ElementType.image.query( dateTimeElement );

    let weekDayElement = new ElementType( "week-info" ).create();
    weekDayElement.innerHTML = weekDayInfo;

    HTMLEditor.addAfter( img, weekDayElement );

    let htmlElement = e as HTMLElement;

    if ( ! cancelled )
    {
      this.addCalenderMaps( e, htmlElement, dateRange );
    }

    let isCalenderEvents = HTMLEditor.findParent( htmlElement, CalenderEvents.calenderEvents.selector );

    if ( ! isCalenderEvents )
    {
      return;
    }

    let showDetails = "Show Details";
    let hideDetails = "Hide Details";

    if ( cancelled )
    {
      let cancelledButton = CalenderEvents.createButton( htmlElement, "CANCELLED", "discarded" ); 
      HTMLEditor.insertBreakBefore( cancelledButton );
      CalenderEvents.cancelled.set( cancelledButton );
    }

      
    let detailsToggle = CalenderEvents.createButton( htmlElement, showDetails ); 

    if ( cancelled )
    {
      CalenderEvents.cancelled.set( detailsToggle );
    }

  
    let detailsToggleImg = ElementType.image.query( detailsToggle );
    let imgSourceAdd = ElementAttribute.src.from( detailsToggleImg );
    let imgSourceMinus = imgSourceAdd.replace( "add.png", "minus.png" );

    CuratedItem.detailsToggle.to( detailsToggle );

    OnSelectStart.add( detailsToggle as HTMLElement, ( ev )=> ev.preventDefault() ) ;

    

    let curatedItem = HTMLEditor.findParent( e, CuratedItem.type.selector ); 
    let curatedCopy = CuratedItem.copy.query( curatedItem );

    let closeButtonType = CuratedItem.closeButton;

    if ( curatedCopy && ! closeButtonType.query( curatedItem ) )
    { 
      let closeButton = closeButtonType.create( "X" );
      curatedItem.appendChild( closeButton );

      OnClick.add( closeButton as HTMLElement, 
        ()=>
        { 
          console.log( "clicking:", detailsToggle );
          ( detailsToggle as HTMLElement ).click();
        }
      );
    }

    OnClick.add( detailsToggle as HTMLElement, 
      ( ev )=>
      {
        let open = CuratedItem.allDetails.in( curatedItem );
        

        open = ! open;

        if ( open )
        {
          CuratedItem.allDetails.set( curatedItem );
          ElementAttribute.src.to( detailsToggleImg, imgSourceMinus );
        }
        else
        {
          CuratedItem.allDetails.removeFrom( curatedItem );
          ElementAttribute.src.to( detailsToggleImg, imgSourceAdd );
        }

        console.log( "Set view of", curatedItem );
        let content = CuratedItem.pointContent.query( detailsToggle );
        content.innerHTML = open ? hideDetails : showDetails;

        ev.preventDefault();
      }
    )
  }

  static addCalenderMaps( e:Element, htmlElement:HTMLElement, dateRange:DateRange )
  {
    let addCuratedPoint = CalenderEvents.createButton( htmlElement, "Add to Calender" );

    HTMLEditor.insertBreakBefore( addCuratedPoint );      

    let createCalenderEvent =
    async () =>
    {
      let year = dateRange.start.getFullYear();
      let month = dateRange.start.getMonth() + 1;
      let day = dateRange.start.getDate();

      let hours = dateRange.start.getHours();
      let minutes = dateRange.start.getMinutes();
      

      console.log( "Calender Date Range", dateRange );
      
      let durationInHours = Math.abs( dateRange.durationInHours );
      let durationInMinutes = Math.abs( dateRange.durationInMinutes ) - durationInHours * 60;

      if ( durationInHours < 2 )
      {
        durationInHours = 2;
      }


      let curatedItem = HTMLEditor.findParent( e, CuratedItem.type.selector ); 

      let titleElement = CuratedItem.title.query( curatedItem );
      let titleValue = ElementType.portraitOnly.query( titleElement );

      let title       = RegExpUtility.collapseWhiteSpace( titleValue.textContent ); 
      let description = RegExpUtility.collapseWhiteSpace( CuratedItem.copy.queryTextContent( curatedItem ) );
      let location    = RegExpUtility.collapseWhiteSpace( CalenderEvents.location.queryTextContent( curatedItem ));
      let eventType   = RegExpUtility.collapseWhiteSpace( CalenderEvents.eventType.queryTextContent( curatedItem ));
      let eventURL    = RegExpUtility.collapseWhiteSpace( new ElementAttribute( "link" ).from( curatedItem ));    

      let monthName = RegExpUtility.upperCaseFirst( DateFormatter.getMonthInEnglish( month - 1 ) );
      let dayCount = DateFormatter.dateToWrittenEnglish( day );
      let dmy = `${dayCount}-${monthName}-${year}`;
      let fileName = RegExpUtility.toFileName( title ) + "_" + dmy + ".ics";

      fileName = RegExpUtility.collapse( fileName, "_" );

      eventURL = eventURL.replace( "::/", "https://rokojori.com/" );


      let calenderEvent = 
      {
        start: [ year, month, day, hours, minutes ],
        duration: { hours: durationInHours, minutes: durationInMinutes },
        title: title,
        description: eventURL + "\n\n" + location + "\n\n" + description,
        location: location,
        url: eventURL,
        categories: [ eventType ],
        status: 'CONFIRMED'
        //, organizer: { name: 'Admin', email: 'Race@BolderBOULDER.com' },
      }
      

      console.log( "Calender Event", calenderEvent );

      let file = await new Promise( (resolve, reject) => 
      {
        createEvent( calenderEvent as any, 
          ( error, value) => 
          {
            if ( error ) 
            {
              console.log( "Error while creating event", calenderEvent, error );
              reject( error );
            }
      
            resolve( new File( [ value ], fileName, { type: 'text/calendar' }))
          }
        )
      })

      let url = URL.createObjectURL( file as any );
    
      // trying to assign the file URL to a window could cause cross-site
      // issues so this is a workaround using HTML5

      let anchor = document.createElement( 'a' );
      anchor.href = url;
      anchor.download = fileName;
    
      document.body.appendChild( anchor );
      anchor.click();
      document.body.removeChild( anchor );
    
      URL.revokeObjectURL( url );

    } 

    OnClick.add( addCuratedPoint as HTMLElement, createCalenderEvent );

    let mapView = CalenderEvents.createButton( htmlElement, "Open in Google Maps" ); 

    OnClick.add( mapView as HTMLElement, 
      ( ev )=>
      {
        let searchApi = "https://www.google.com/maps/search/?api=1&query=";

        let curatedItem = HTMLEditor.findParent( e, CuratedItem.type.selector ); 
        let location    = RegExpUtility.collapseWhiteSpace( CalenderEvents.location.queryTextContent( curatedItem ));

        let locationEncoded = encodeURIComponent( location ).replace( /%20/g, "+" );
        let url = searchApi + locationEncoded;

        console.log( url );

        let anchor = document.createElement( "a" );        
        anchor.href = url;
        AttributeValue.target_blank.set( anchor );

        document.body.appendChild( anchor );
        anchor.click();
        document.body.removeChild( anchor );
      }
    );
  }
}